<!--  -->
<template>
  <div class="classification">
    <div class="header">
      <span class="font">经营范围</span>
    </div>

    <div class="center"
         style="position:relative">
      <div class="shangjia">
        <el-button size="small"
                   type="primary"
                   @click="clickBtn('add')">添加经营范围</el-button>
      </div>
      <MyTable :table-data="tableData"
               :showpage="showpage"
               :index="index"
               :operation="operation"
               :table-option.sync="tableOption">
        <template slot="menu"
                  slot-scope="scope">
          <!-- <el-button type="button" size="mini" icon="el-icon-upload2" @click="deleteHandle(scope.row)">上架</el-button> -->

          <el-link :underline="false"
                   type="primary"
                   @click="editHandle(scope.row)">编辑</el-link>
          <el-link :underline="false"
                   style="margin-left:16px"
                   type="primary"
                   @click="deleteHandle(scope.row)">删除</el-link>
        </template>
      </MyTable>
    </div>

    <el-dialog title="经营范围"
               :visible.sync="dialogVisible"
               width="500px"
               :before-close="handleClose">
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="110px"
               class="demo-ruleForm">
        <el-form-item label="经营范围名称"
                      prop="name">
          <el-input v-model="ruleForm.name"
                    size="small"></el-input>
        </el-form-item>
        <el-form-item label="排序"
                      prop="sort">
          <el-input v-model.number="ruleForm.sort"
                    size="small"
                    type="number"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="handleClose"
                   size="small">取消</el-button>
        <el-button type="primary"
                   size="small"
                   @click="submit">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="删除经营范围"
               :visible.sync="dialogVisibleDelete"
               width="30%"
               :before-close="handleCloseDelete">
      <span>请确认是否要删除经营范围</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button size="small"
                   @click="dialogVisibleDelete = false">取消</el-button>
        <el-button size="small"
                   type="primary"
                   @click="deleteShop">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyTable from '@/components/myTable'
import { queryScopeList, compBusinessScopeDeleteOne, compBusinessScopeUpdate, compBusinessScopeQuery, compBusinessScopeAdd } from '@/api/productManage/goodsManger'
// import avater from "/public/img/default.png"

export default {
  name: 'WareProduct',
  components: { MyTable },
  data () {
    return {
      row: {},
      type: 'add',
      dialogVisibleDelete: false,
      showpage: false,
      dialogVisible: false,
      ruleForm: {
        name: '',
        sort: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
        ],
        sort: [{ required: true, message: '请输入排序数字', trigger: 'blur' }]
      },
      // avater: avater,
      // formTool: {
      //   name: '',
      //   approvalNumber: ''
      // },
      // selectionList: [],
      operation: true,
      // selection: true,
      index: false,
      tableData: [],
      tableOption: [
        // { label: '商品信息', prop: 'image', slot: true, minWidth: '200px' }, // 这里表示自定义列
        // { label: '商品名称', prop: 'name' },
        // { label: '生产厂商', prop: 'factory' },
        { label: '经营范围ID', prop: 'id' },
        { label: '经营范围名称', prop: 'name' },
        { label: '商品数', prop: 'shopNumber' },
        { label: '排序', prop: 'sort' }
      ]
    }
  },
  computed: {},
  watch: {},
  created () {
    this.queryScopeList()
  },
  mounted () {

  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  methods: {
    handleCloseDelete () {
      this.dialogVisibleDelete = false
    },
    // 确定删除
    deleteShop () {
      compBusinessScopeDeleteOne({ id: this.row.id }).then(res => {
        if (res.code == 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.success('删除失败')
        }
        this.dialogVisibleDelete = false
        this.queryScopeList()
      })
    },
    // 新增
    clickBtn (type) {
      if (type == 'add') {
        this.type = 'add'
        this.dialogVisible = true
      } else {
        this.type = 'edit'
        this.dialogVisible = true
      }
    },
    // 手动关闭弹窗
    handleClose () {
      this.ruleForm.name = ''
      this.ruleForm.sort = ''
      this.dialogVisible = false
    },
    // 提交信息
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            let params = {
              ...this.ruleForm
            }
            compBusinessScopeAdd(params).then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功')
                this.queryScopeList()
              } else {
                this.$message.error('新增失败')
              }
              this.handleClose()
            })
          } else {
            let params = {
              ...this.ruleForm,
              id: this.row.id
            }
            compBusinessScopeUpdate(params).then(res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.queryScopeList()
              } else {
                this.$message.error('操作失败')
              }
            })
            this.handleClose()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    // 编辑sku
    editHandle (row) {
      this.row = row
      this.ruleForm.name = row.name
      this.ruleForm.sort = row.sort
      this.clickBtn('edit')
    },
    // 删除
    deleteHandle (row) {
      this.row = row
      if (row.shopNumber > 0) {
        this.$message({
          type: 'error',
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: '<div><span style="font-size:16px">无法删除经营范围</span><div>该经营范围下还有商品，请清除经营范围内的商品，再删除经营范围</div></div>',
        })
      } else {
        this.dialogVisibleDelete = true
      }
    },
    // 查询
    queryScopeList (current) {
      queryScopeList().then(res => {
        if (res.code == 0 && res.data) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
  }
}
</script>
<style lang='scss' scoped>
.classification {
  padding: 0px;
}
.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  .font {
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 600;
    text-align: left;
    color: #262626;
  }
  .el-form-item {
    margin: 0px 0px 0px 8px !important;
  }
}
.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  height: calc(100% - 120px);
  ::v-deep .imageP {
    width: calc(100% - 110px);
    p {
      margin: 0 0 0 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .shangjia {
    // position: absolute;
    // z-index: 2;
    // bottom: -45px;
  }
  ::v-deep .el-dialog__body {
    padding-bottom: 0px;
  }
}
</style>
